import { ILazyAsynchronousFunction } from "./ILazyAsynchronousFunction";

import { IPromise } from "./IPromise";
import { Assert } from "../Utils/Assert";

export class LazyAsynchronousFunction<TResult, TErrors> implements ILazyAsynchronousFunction<TResult, TErrors> {
    private _underlyingFunc: () => IPromise<TResult, TErrors>;
    private _result: IPromise<TResult, TErrors>;

    constructor(func: () => IPromise<TResult, TErrors>) {
        this._underlyingFunc = func;
    }

    public run(): IPromise<TResult, TErrors> {
        Assert(!this.hasAlreadyStarted(), "Attempting to run already started LazyAsynchronouseFunction");
        this._result = this._underlyingFunc();
        return this._result;
    }

    public getResult(): IPromise<TResult, TErrors> {
        Assert(this.hasAlreadyFinished(), "Attempting to get result of not finished LazyAsynchronouseFunction");
        return this._result;
    }

    public hasAlreadyFinished(): boolean {
        return this._result != null && this._result.isFinished();
    }

    public hasAlreadyStarted(): boolean {
        return this._result != null;
    }
}
